<template>
  <div class="login-wrapper">
    <div class="login-box">
      <img src="@/assets/kakao-login.png" alt="카카오 로그인" @click="loginWithKakao" />
      <p>카카오 계정으로 로그인 해주세요</p>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'LoginView',
  setup() {
    const router = useRouter();
    return { router };
  },
  mounted() {
    if (!window.Kakao || !window.Kakao.isInitialized()) {
      const script = document.createElement('script');
      script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
      script.onload = () => {
        window.Kakao.init('f4ce4d051903b1cfc9f3e59ac8046c0b');
        console.log('✅ Kakao SDK initialized');
      };
      document.head.appendChild(script);
    }
  },
  methods: {
    loginWithKakao() {
      if (!window.Kakao || !window.Kakao.Auth) {
        alert('카카오 SDK가 아직 로딩되지 않았습니다.');
        return;
      }

      window.Kakao.Auth.login({
        scope: 'profile_nickname, profile_image',
        success: () => {
          window.Kakao.API.request({
            url: '/v2/user/me',
            success: async (res) => {
               console.log('🟢 카카오 로그인 성공:', res); // ✅ 디버깅용 로그

              const userInfo = {
                kakaoId: res.id,
                nickname: res.kakao_account.profile.nickname,
                profileImage: res.kakao_account.profile.profile_image_url,
              };

              localStorage.setItem('user', JSON.stringify(userInfo));
              try {
                console.log('🚀 UUID 발급 요청 시작');
                const uuidRes = await fetch('/api/users/uuid', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    socialId: res.id,
                    platform: 'kakao',
                  }),
                });

                if (!uuidRes.ok) {
                  throw new Error(`HTTP error! status: ${uuidRes.status}`);
                }

                const { uuid } = await uuidRes.json();
                localStorage.setItem('userUUID', uuid);
                console.log('✅ UUID 저장 완료:===============>>', uuid);

                const redirectPath = localStorage.getItem('redirectAfterLogin') || '/dashboard';
                localStorage.removeItem('redirectAfterLogin');
                this.router.push(redirectPath);
              } catch (err) {
                console.error('❌ UUID 요청 실패:', err);
              }
            },
            fail: (err) => {
              console.error('사용자 정보 요청 실패:', err);
              alert('카카오 사용자 정보 요청 실패');
            },
          });
        },
        fail: (err) => {
          console.error('카카오 로그인 실패:', err);
          alert('카카오 로그인 실패');
        },
      });
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90vh;
  background-color: #f5f5f5;
}

.login-box {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-box img {
  width: 240px;
  cursor: pointer;
}

.login-box p {
  margin-top: 16px;
  color: #555;
  font-size: 16px;
}
</style>
